import React from "react";
import { useTranslation } from "react-i18next";
import { FaWhatsapp } from "react-icons/fa";
import "./floatingbuttons.css";

const FloatingButtons = () => {
  const { t } = useTranslation('floatingbuttons');

  return (
    <div className="floating-buttons">
      <button
        className="floating-btn whatsapp-btn"
        onClick={() =>
          window.open(
            "https://wa.me/4917623379785",
            "_blank"
          )
        }
      >
        <FaWhatsapp className="btn-icon" /> {t('contactWhatsapp')}
      </button>
    </div>
  );
};

export default FloatingButtons;